export default __webpack_public_path__ + "36b75aba7e43f9f667a8446f16b7c009.svg";